import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Usia Masehi - Hitung Usia Anda dengan Hijriah dan Masehi Secara Akurat";
const DESCRIPTION =
  "Hitung usia Anda secara akurat dengan kalender Hijriah atau Masehi. Kalkulator usia elektronik yang akurat menampilkan usia Anda dalam tahun, bulan, hari, dan jam, dengan informasi tambahan tentang hari kelahiran Anda dan hari-hari tersisa hingga ulang tahun Anda berikutnya";
const KEYWORDS =
  "perhitungan usia, hitung usia saya dengan hijriah, hitung usia saya dengan masehi, kalkulator usia, berapa umur saya, usia masehi, perhitungan usia dalam menit, perhitungan usia dalam hari, konversi usia, usia masehi, perhitungan usia seseorang, kalkulator usia akurat";
const OG_URL = "https://do-calculate.com/calculator/id/agegregorian/";
// JSON-LD Schema for SEO
const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Kalkulator Usia Masehi",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Semua Kalkulator",
        item: "https://do-calculate.com/id/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Kalkulator Usia Masehi",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Apa itu usia Masehi?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Usia Masehi adalah cara yang kita gunakan untuk mengukur usia seseorang berdasarkan tanggal lahirnya menurut kalender Masehi bulanan dan tahunan.",
        },
      },
      {
        "@type": "Question",
        name: "Bagaimana cara menghitung usia Masehi?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Anda dapat menghitung usia Masehi dengan memasukkan tanggal lahir Anda ke dalam kalkulator, dan kalkulator akan secara otomatis menghitung usia Anda dalam tahun, bulan, hari, dan jam dengan sangat akurat.",
        },
      },
      {
        "@type": "Question",
        name: "Apa saja kegunaan menghitung usia Masehi?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Perhitungan usia Masehi digunakan dalam merenungkan pengalaman hidup, perencanaan masa depan, penetapan tujuan pribadi, serta dalam bidang asuransi, pensiun, dan perawatan kesehatan.",
        },
      },
    ],
  },
];
const DAYS_OF_WEEK = [
  "Minggu",
  "Senin",
  "Selasa",
  "Rabu",
  "Kamis",
  "Jumat",
  "Sabtu",
];
const GREGORIAN_MONTHS = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];
const HIJRI_MONTHS = [
  "Muharram",
  "Safar",
  "Rabiul Awal",
  "Rabiul Akhir",
  "Jumadil Awal",
  "Jumadil Akhir",
  "Rajab",
  "Sya'ban",
  "Ramadhan",
  "Syawal",
  "Dzulqa'dah",
  "Dzulhijjah",
];
const SEASONS = [
  {
    name: "Musim Dingin",
    start: { month: 12, day: 21 },
    end: { month: 3, day: 20 },
  },
  { name: "Musim Semi", start: { month: 3, day: 21 }, end: { month: 6, day: 20 } },
  { name: "Musim Panas", start: { month: 6, day: 21 }, end: { month: 9, day: 22 } },
  {
    name: "Musim Gugur",
    start: { month: 9, day: 23 },
    end: { month: 12, day: 20 },
  },
];

const CURRENT_YEAR = new Date().getFullYear();
const CURRENT_HIJRI_YEAR = Math.floor((CURRENT_YEAR - 622) * 1.03);

// Helper function to convert Hijri to Gregorian
const hijriToGregorian = (hijriDay, hijriMonth, hijriYear) => {
  // This is a simplified conversion. For production, use a proper library like hijri-converter
  const adjustment = Math.floor(hijriYear * 0.97); // Approximate adjustment factor
  const gregorianYear = hijriYear + 622 - adjustment;
  // Simplified month and day mapping (this is not accurate, just for demonstration)
  // In production, use a proper conversion library
  const monthDays = [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29]; // Hijri months
  let totalDays = 0;
  for (let i = 0; i < hijriMonth - 1; i++) {
    totalDays += monthDays[i];
  }
  totalDays += hijriDay - 1;
  // Convert to Gregorian days (approximate)
  const gregorianDays = Math.floor(totalDays * 1.0307);
  const date = new Date(gregorianYear, 0, 1);
  date.setDate(date.getDate() + gregorianDays);
  return date;
};

function AgeCalculatorGregorian() {
  const [convertedValue, setConvertedValue] = useState("gregorian");
  const [dateOfBirthGregorian, setDateOfBirthGregorian] = useState({
    day: "",
    month: "",
    year: ""
  });
  const [dateOfBirthHijri, setDateOfBirthHijri] = useState({
    day: "",
    month: "",
    year: ""
  });
  const [ageResult, setAgeResult] = useState(null);
  const [error, setError] = useState(null);
  const [hijriYears, setHijriYears] = useState([]);
  // Generate Hijri years list
  useEffect(() => {
    const years = [];
    for (let year = 1300; year <= CURRENT_HIJRI_YEAR + 10; year++) {
      years.push(year);
    }
    setHijriYears(years);
  }, []);

  const handleConversionValueChange = (newConversionType) => {
    setConvertedValue(newConversionType);
    setError(null);
    setDateOfBirthGregorian({ day: "", month: "", year: "" });
    setDateOfBirthHijri({ day: "", month: "", year: "" });
    setAgeResult(null);
  };
  const calculateAge = (birthDate, isHijri = false) => {
    const today = new Date();
    const birth = new Date(birthDate);
    if (isNaN(birth.getTime()) || birth > today) {
      setError("Harap masukkan tanggal lahir yang valid");
      setAgeResult(null);
      return;
    }
    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();
    let days = today.getDate() - birth.getDate();
    if (days < 0) {
      months--;
      const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }
    const hours = today.getHours() - birth.getHours();
    const minutes = today.getMinutes() - birth.getMinutes();
    const seconds = today.getSeconds() - birth.getSeconds();
    // Calculate total time units
    const totalDays = Math.floor((today - birth) / (1000 * 60 * 60 * 24));
    const totalHours = Math.floor((today - birth) / (1000 * 60 * 60));
    const totalMinutes = Math.floor((today - birth) / (1000 * 60));
    const totalSeconds = Math.floor((today - birth) / 1000);
    const totalWeeks = Math.floor(totalDays / 7);
    const totalMonths = years * 12 + months;
    // Calculate next birthday
    let nextBirthday = new Date(
      today.getFullYear(),
      birth.getMonth(),
      birth.getDate()
    );
    if (nextBirthday < today) {
      nextBirthday.setFullYear(today.getFullYear() + 1);
    }
    const daysUntilBirthday = Math.ceil(
      (nextBirthday - today) / (1000 * 60 * 60 * 24)
    );
    // Get day of week born
    const dayOfWeekBorn = DAYS_OF_WEEK[birth.getDay()];
    // Get birth month in Arabic
    const birthMonthArabic = isHijri
      ? HIJRI_MONTHS[birth.getMonth()]
      : GREGORIAN_MONTHS[birth.getMonth()];
    // Get season born
    const birthMonth = birth.getMonth() + 1;
    const birthDay = birth.getDate();
    let seasonBorn = "";
    for (const season of SEASONS) {
      if (season.name === "Musim Dingin") {
        if (birthMonth === 12 || birthMonth <= 3) {
          if (
            (birthMonth === 12 && birthDay >= 21) ||
            birthMonth < 3 ||
            (birthMonth === 3 && birthDay <= 20)
          ) {
            seasonBorn = season.name;
            break;
          }
        }
      } else {
        const inStartRange =
          birthMonth > season.start.month ||
          (birthMonth === season.start.month && birthDay >= season.start.day);
        const inEndRange =
          birthMonth < season.end.month ||
          (birthMonth === season.end.month && birthDay <= season.end.day);
        if (inStartRange && inEndRange) {
          seasonBorn = season.name;
          break;
        }
      }
    }
    // Life milestone
    let lifeMilestone = "";
    if (years < 1) lifeMilestone = "Bayi";
    else if (years < 3) lifeMilestone = "Balita";
    else if (years < 13) lifeMilestone = "Anak-anak";
    else if (years < 20) lifeMilestone = "Remaja";
    else if (years < 40) lifeMilestone = "Dewasa Muda";
    else if (years < 60) lifeMilestone = "Dewasa";
    else lifeMilestone = "Lansia";
    setAgeResult({
      years,
      months,
      days,
      hours: Math.abs(hours),
      minutes: Math.abs(minutes),
      seconds: Math.abs(seconds),
      totalDays,
      totalHours,
      totalMinutes,
      totalSeconds,
      totalWeeks,
      totalMonths,
      daysUntilBirthday,
      dayOfWeekBorn,
      birthMonthArabic,
      seasonBorn,
      lifeMilestone,
      heartbeats: Math.floor(totalDays * 100000),
      breaths: Math.floor(totalDays * 20000),
      sleepHours: Math.floor(totalHours / 3),
      mealsEaten: Math.floor(totalDays * 3),
    });
    setError(null);
  };
  const handleCalculate = () => {
    if (convertedValue === "gregorian") {
      if (!dateOfBirthGregorian.day || !dateOfBirthGregorian.month || !dateOfBirthGregorian.year) {
        setError("Harap masukkan tanggal lahir secara lengkap");
        return;
      }
      // Validate day based on month
      const day = parseInt(dateOfBirthGregorian.day);
      const month = parseInt(dateOfBirthGregorian.month);
      const year = parseInt(dateOfBirthGregorian.year);
      // Check for valid date
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
      ) {
        setError("Tanggal lahir tidak valid");
        return;
      }
      // Create date string in YYYY-MM-DD format
      const dateString = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      calculateAge(dateString, false);
    } else {
      if (!dateOfBirthHijri.day || !dateOfBirthHijri.month || !dateOfBirthHijri.year) {
        setError("Harap masukkan tanggal lahir secara lengkap");
        return;
      }
      const hijriDay = parseInt(dateOfBirthHijri.day);
      const hijriMonth = parseInt(dateOfBirthHijri.month);
      const hijriYear = parseInt(dateOfBirthHijri.year);
      // Simple validation for Hijri date
      if (hijriDay < 1 || hijriDay > 30 || hijriMonth < 1 || hijriMonth > 12 || hijriYear < 1) {
        setError("Tanggal Hijriah tidak valid");
        return;
      }
      // Convert Hijri to Gregorian for calculation
      const gregorianDate = hijriToGregorian(hijriDay, hijriMonth, hijriYear);
      calculateAge(gregorianDate, true);
    }
  };
  // Get days in month for Hijri
  const getHijriDaysInMonth = (month) => {
    // Hijri months have 29 or 30 days
    const longMonths = [1, 3, 5, 7, 9, 11]; // Odd months are usually 30 days
    if (longMonths.includes(parseInt(month))) {
      return 30;
    }
    return 29; // Even months are usually 29 days
  };
  return (
    <div >
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>Kalkulator Usia Elektronik</strong> memungkinkan Anda menentukan usia
                Anda secara akurat dalam kalender Masehi atau Hijriah. Alat ini menjawab
                pertanyaan seperti: "Berapa tepatnya usia saya?" dan "Bagaimana cara menghitung usia saya?" Yang perlu Anda lakukan
                adalah memasukkan tanggal lahir Anda dalam hari, bulan, dan tahun, dan kalkulator akan
                menghitung usia Anda dalam tahun, bulan, dan hari dengan sangat akurat.
              </p>
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                Kalkulator usia hadir dengan fitur tambahan yaitu <strong>menghitung usia dalam menit</strong>
                dan detik. Anda akan dapat mengetahui berapa menit yang telah Anda habiskan di
                planet ini dengan sangat akurat, ditambah informasi menarik lainnya tentang hidup Anda.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds /> <hr />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-3">
              <div className="p-3 mb-3 bg-success text-white rounded text-center">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Hitung Usia Anda Sekarang</h2>
              </div>
              <div className="row">
                <div
                  className="form-group d-flex align-items-center"
                  style={{
                    columnGap: "25px",
                    margin: "5px 15px 25px 0",
                  }}
                >
                  <label >
                    <strong>Jenis Tanggal:</strong>
                  </label>
                  <div>
                    <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span>Masehi</span>
                      <input
                        type="radio"
                        name="calendarType"
                        value="gregorian"
                        onChange={() => handleConversionValueChange("gregorian")}
                        checked={convertedValue === "gregorian"}
                      />
                    </label>

                    <label style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "8px" }}>
                      <span>Hijriah</span>
                      <input
                        type="radio"
                        name="calendarType"
                        value="hijri"
                        onChange={() => handleConversionValueChange("hijri")}
                        checked={convertedValue === "hijri"}
                      />
                    </label>
                  </div>
                </div>
              </div>
              {convertedValue === "gregorian" ? (
                <div className="row">
                  <div className="col-md-12">
                    <label
                      htmlFor="dateOfBirth"

                      style={{ fontSize: "16px" }}
                    >
                      Masukkan tanggal lahir Anda dalam kalender Masehi:
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <label style={{ fontSize: "14px" }}>Hari</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.day || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, day: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Hari</option>
                          {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                            <option key={day} value={day}>{day}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label style={{ fontSize: "14px" }}>Bulan</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.month || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, month: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Bulan</option>
                          {GREGORIAN_MONTHS.map((month, index) => (
                            <option key={index} value={index + 1}>{month}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label style={{ fontSize: "14px" }}>Tahun</label>
                        <select
                          className="form-control"
                          value={dateOfBirthGregorian.year || ""}
                          onChange={(e) => setDateOfBirthGregorian({ ...dateOfBirthGregorian, year: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Tahun</option>
                          {Array.from(
                            { length: CURRENT_YEAR - 1899 },
                            (_, i) => CURRENT_YEAR - i
                          ).map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-12">
                    <label
                      htmlFor="hijriDatePicker"

                      style={{ fontSize: "16px" }}
                    >
                      Masukkan tanggal lahir Anda dalam kalender Hijriah:
                    </label>
                    <div className="row">
                      <div className="col-md-4">
                        <label style={{ fontSize: "14px" }}>Hari</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.day || ""}
                          onChange={(e) => {
                            setDateOfBirthHijri({ ...dateOfBirthHijri, day: e.target.value });
                          }}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Hari</option>
                          {dateOfBirthHijri.month ?
                            Array.from(
                              { length: getHijriDaysInMonth(dateOfBirthHijri.month) },
                              (_, i) => i + 1
                            ).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))
                            :
                            Array.from({ length: 30 }, (_, i) => i + 1).map(day => (
                              <option key={day} value={day}>{day}</option>
                            ))
                          }
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label style={{ fontSize: "14px" }}>Bulan</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.month || ""}
                          onChange={(e) => {
                            setDateOfBirthHijri({ ...dateOfBirthHijri, month: e.target.value, day: "" });
                          }}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Bulan</option>
                          {HIJRI_MONTHS.map((month, index) => (
                            <option key={index} value={index + 1}>{month}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label style={{ fontSize: "14px" }}>Tahun</label>
                        <select
                          className="form-control"
                          value={dateOfBirthHijri.year || ""}
                          onChange={(e) => setDateOfBirthHijri({ ...dateOfBirthHijri, year: e.target.value })}
                          style={{ fontSize: "16px", padding: "10px" }}
                        >
                          <option value="">Tahun</option>
                          {hijriYears.map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <br />
              <div className="text-center mb-3 mt-4">
                <button
                  className="btn btn-success"
                  onClick={handleCalculate}
                >
                  Hitung Usia Saya
                </button>
              </div>
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>Peringatan:</strong> {error}
                </div>
              )}
              {ageResult && (
                <div
                  className="alert alert-success"
                  role="alert"
                  style={{ fontSize: "16px" }}
                >
                  <h3 style={{ fontSize: "20px", marginBottom: "15px" }}>
                    <strong>Hasil Perhitungan Usia:</strong>
                  </h3>
                  <div className="mb-3 p-3 bg-light rounded">
                    <strong style={{ fontSize: "18px" }}>Usia Anda:</strong>
                    <p style={{ fontSize: "17px", marginTop: "10px" }}>
                      {ageResult.years} tahun {ageResult.months} bulan{" "}
                      {ageResult.days} hari
                    </p>
                  </div>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Usia Anda Secara Detail</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>✓ Tahun: {ageResult.years}</li>
                          <li>✓ Bulan: {ageResult.months}</li>
                          <li>✓ Hari: {ageResult.days}</li>
                          <li>✓ Jam: {ageResult.hours}</li>
                          <li>✓ Menit: {ageResult.minutes}</li>
                          <li>✓ Detik: {ageResult.seconds}</li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Statistik Total</strong>
                      </div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            📅 Total Hari yang Dijalani:{" "}
                            {ageResult.totalDays.toLocaleString()} hari
                          </li>
                          <li>
                            📅 Total Minggu:{" "}
                            {ageResult.totalWeeks.toLocaleString()} minggu
                          </li>
                          <li>
                            📅 Total Bulan:{" "}
                            {ageResult.totalMonths.toLocaleString()} bulan
                          </li>
                          <li>
                            ⏰ Total Jam:{" "}
                            {ageResult.totalHours.toLocaleString()} jam
                          </li>
                          <li>
                            ⏰ Total Menit:{" "}
                            {ageResult.totalMinutes.toLocaleString()} menit
                          </li>
                          <li>
                            ⏰ Total Detik:{" "}
                            {ageResult.totalSeconds.toLocaleString()} detik
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>Informasi Menarik tentang Hidup Anda</strong>
                      </div>
                      <div className="info-section-body">
                        <h4 style={{ fontSize: "16px", marginBottom: "10px" }}>
                          Informasi Umum:
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>🗓️ Anda lahir pada hari: {ageResult.dayOfWeekBorn}</li>
                          <li>📅 Pada bulan: {ageResult.birthMonthArabic}</li>
                          <li>🌸 Pada musim: {ageResult.seasonBorn}</li>
                          <li>
                            🎂 Hari tersisa hingga ulang tahun Anda berikutnya:{" "}
                            {ageResult.daysUntilBirthday} hari
                          </li>
                          <li>👤 Tahap kehidupan: {ageResult.lifeMilestone}</li>
                        </ul>
                        <h4
                          style={{
                            fontSize: "16px",
                            marginTop: "15px",
                            marginBottom: "10px",
                          }}
                        >
                          Fakta Menakjubkan yang Terjadi dalam Hidup Anda (Perkiraan):
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0 }}>
                          <li>
                            💓 Detak jantung Anda sekitar:{" "}
                            {ageResult.heartbeats.toLocaleString()} kali
                          </li>
                          <li>
                            🫁 Anda bernapas sekitar:{" "}
                            {ageResult.breaths.toLocaleString()} napas
                          </li>
                          <li>
                            😴 Anda menghabiskan waktu tidur sekitar:{" "}
                            {ageResult.sleepHours.toLocaleString()} jam (
                            {Math.floor(ageResult.sleepHours / 24).toLocaleString()}{" "}
                            hari)
                          </li>
                          <li>
                            🍽️ Anda makan sekitar:{" "}
                            {ageResult.mealsEaten.toLocaleString()} porsi
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>
                  Pemahaman Lebih Dalam tentang Usia dalam Tanggal Masehi dan Penggunaan Kalkulator Akurat
                </strong>
              </div>
              <div className="info-section-body">
                <h2 style={{ fontSize: "18px", marginBottom: "15px" }}>
                  Usia dalam Tanggal Masehi: Panduan Lengkap untuk Menghitung Usia dengan Akurat
                </h2>
                <p style={{ lineHeight: "1.8" }}>
                  Usia dianggap sebagai konsep penting dalam kehidupan manusia, dan dapat diperkirakan
                  dengan berbagai metode tergantung pada budaya dan tradisi. Di antara metode ini,
                  kita menemukan perhitungan usia dalam tanggal Masehi yang didasarkan pada kalender
                  Masehi. Jenis perhitungan ini memungkinkan konversi tanggal menjadi usia
                  aktual dengan akurat, dan menyajikan hasil yang akurat yang berkontribusi pada pemahaman yang lebih dalam tentang waktu yang telah dilalui seseorang.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "20px" }}>
                  Kalender Masehi dan Sejarahnya
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Penggunaan kalender Masehi untuk menghitung usia manusia berasal dari sejarah
                  Barat dan Kristen. Kalender Masehi didasarkan pada kalender
                  Gregorian, yang ditetapkan pada tahun 1582 oleh Paus
                  Gregorius XIII dari Vatikan. Dalam kalender Masehi, satu tahun
                  terdiri dari 365 hari, kecuali tahun kabisat yang memiliki satu hari
                  tambahan di bulan Februari. Kalender ini diadopsi karena kesesuaiannya dengan siklus bumi
                  mengelilingi matahari secara lebih akurat.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "20px" }}>
                  Cara Menghitung Usia dalam Kalender Masehi
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Usia seseorang dihitung dengan berbagai cara dalam budaya yang berbeda. Kalkulator ini didasarkan
                  pada sistem usia yang paling umum. Dalam sistem ini, usia bertambah pada
                  hari ulang tahun seseorang. Misalnya, usia seseorang yang telah hidup selama 3
                  tahun 11 bulan adalah 3, dan usianya akan bertambah menjadi 4 pada ulang tahun berikutnya
                  setelah satu bulan. Sebagian besar negara Barat menggunakan sistem usia ini.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "20px" }}>
                  Sistem Usia dalam Berbagai Budaya
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Dalam beberapa budaya, usia dinyatakan dengan menghitung tahun dengan atau
                  tanpa memasukkan tahun berjalan. Dalam salah satu sistem usia tradisional
                  Tiongkok, orang lahir dengan usia 1 dan usia mereka bertambah pada Tahun Baru
                  tradisional Tiongkok, bukan pada hari ulang tahun mereka. Sebagai contoh, jika seorang
                  anak lahir satu hari sebelum Tahun Baru tradisional Tiongkok,
                  setelah dua hari, usia anak tersebut akan menjadi 2 meskipun ia berada di tahun kedua.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "20px" }}>
                  Menggunakan Kalkulator Usia Profesional
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Gunakan kalkulator usia profesional ini untuk mengonversi tanggal menjadi usia
                  secara detail, dengan mempertimbangkan kalender Masehi. Anda akan dapat mengonversi
                  tanggal lahir Anda menjadi usia aktual dengan akurat, dan memanfaatkan perhitungan yang didasarkan
                  pada kalender Masehi. Baik Anda perlu menghitung usia dalam tanggal
                  Masehi, atau mengonversi tanggal menjadi tahun, kalkulator akurat ini
                  menawarkan solusi terbaik untuk Anda.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Menghitung Usia Secara Elektronik - Kecepatan dan Akurasi</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Beberapa orang berpikir bahwa pikiran manusia mampu mengetahui usia secara intuitif
                  atau lisan. Meskipun pikiran manusia mampu melakukan operasi
                  matematika dengan akurat, proses ini mungkin memakan waktu lama.
                  Anda mungkin membutuhkan satu menit atau lebih, tergantung pada intuisi seseorang
                  dan keterampilan mereka dalam matematika dan perhitungan.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Keunggulan Perhitungan Elektronik:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Kecepatan:</strong> Program perhitungan usia elektronik memberikan
                    hasil instan dalam hitungan detik
                  </li>
                  <li>
                    <strong>Akurasi:</strong> Perhitungan 100% akurat dengan mempertimbangkan tahun
                    kabisat dan bulan yang berbeda
                  </li>
                  <li>
                    <strong>Kemudahan:</strong> Tidak memerlukan pengalaman matematika atau perhitungan
                  </li>
                  <li>
                    <strong>Detail:</strong> Menyediakan informasi komprehensif dalam tahun,
                    bulan, hari, jam, menit, dan detik
                  </li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "15px" }}>
                  Oleh karena itu, metode perhitungan usia elektronik dianggap lebih mudah, lebih cepat, dan lebih akurat
                  daripada metode perhitungan lisan tradisional yang dilakukan oleh pikiran manusia.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Menghitung Usia dalam Hari - Kalkulator Usia dalam Hari</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Sistem kami didasarkan pada derivasi akurat jumlah hari antara hari ulang tahun Anda
                  dan hari ini, menggunakan persamaan pemrograman yang akurat dan dipelajari dengan sangat
                  cermat. Persamaan ini diterapkan pada data yang Anda masukkan, sehingga perhitungan usia dalam hari konsisten baik dalam
                  kalender Hijriah maupun Masehi.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Mengapa Menghitung Usia dalam Hari Penting?
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Hari adalah satuan waktu yang tetap dalam semua kalender</li>
                  <li>
                    Tidak terpengaruh oleh perbedaan antara kalender Hijriah dan Masehi sebanyak
                    tahun
                  </li>
                  <li>Memberikan pengukuran usia yang akurat saat membandingkan kedua kalender</li>
                  <li>
                    Berguna dalam perhitungan medis dan ilmiah yang memerlukan akurasi tinggi
                  </li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "15px" }}>
                  Hari dianggap sebagai satuan pengukuran dasar dalam kalender apa pun, terlepas dari jenisnya.
                  Perbedaan antara kalender dihitung setiap 33 tahun Masehi kira-kira. Seiring
                  bertambahnya usia, perbedaan ini secara bertahap meningkat, tetapi pengukuran usia
                  dalam hari tetap bebas dari perbedaan dan variasi antara kalender.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Berapa Usia Saya - Hitung Usia Anda dengan Akurat</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Pertanyaan yang mengisi banyak pikiran setiap hari adalah "Berapa usia saya?" Oleh karena itu, kami menyediakan
                  layanan "Hitung Usia Anda" yang memberikan jawaban akurat untuk pertanyaan ini
                  dalam tanggal Masehi. Selain itu, layanan ini menyediakan kemampuan untuk mengetahui
                  usia Anda dalam kalender Hijriah, yang memiliki perbedaan sekitar sebelas hari setiap tahun.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Manfaat Menghitung Usia Secara Teratur:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Selalu mengetahui usia Anda yang tepat</li>
                  <li>Melacak tonggak usia yang penting</li>
                  <li>Merencanakan masa depan berdasarkan usia Anda saat ini</li>
                  <li>Mengetahui waktu tersisa untuk acara penting</li>
                  <li>Membandingkan usia Anda dengan rata-rata harapan hidup</li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "15px" }}>
                  Dengan menggunakan teknologi informasi dan mengarahkannya untuk operasi
                  perhitungan ini, menjadi mudah untuk menghitung usia dengan akurat dan mudah, tanpa perlu
                  pemikiran manusia tradisional yang memakan waktu dan tenaga. Yang
                  perlu Anda lakukan adalah mengatur tanggal lahir Anda, dan layanan akan memberi Anda hasil
                  yang diinginkan secara instan dan akurat.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Berapa Lama Lagi hingga Ulang Tahun Saya?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Di antara informasi yang sangat menarik yang diberikan sistem kami adalah mengetahui
                  waktu yang tersisa dengan tepat hingga ulang tahun Anda berikutnya. Ini dilakukan
                  dengan menghitung tanggal lahir dan menurunkan sisa waktu secara detail, yang ditampilkan
                  dalam hari dengan sangat akurat.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Pentingnya Mengetahui Waktu Tersisa hingga Ulang Tahun Anda:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Perencanaan awal untuk merayakan ulang tahun Anda</li>
                  <li>Mengatur kejutan untuk orang yang dicintai pada hari ulang tahun mereka</li>
                  <li>Persiapan mental untuk memulai tahun baru dalam hidup Anda</li>
                  <li>Berbagi hitungan mundur dengan teman dan keluarga</li>
                  <li>Menambah kegembiraan dan antisipasi untuk acara tersebut</li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "15px" }}>
                  Jangan lupa juga untuk memanfaatkan layanan ini untuk mengetahui berapa lama tersisa
                  hingga ulang tahun orang yang Anda cintai, untuk berbagi dengan mereka dalam acara bahagia ini dan menambah kegembiraan dan kesenangan. Anda dapat membagikan situs kami dengan mereka untuk menambah momen bahagia dalam hidup mereka dan membuat perayaan mereka lebih istimewa.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>Penggunaan Perhitungan Usia dalam Kehidupan Sehari-hari</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Penggunaan Pribadi:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Mengetahui usia yang tepat Anda untuk dokumen resmi</li>
                  <li>Menghitung usia anak untuk memantau pertumbuhan dan perkembangan mereka</li>
                  <li>Menentukan usia yang sesuai untuk mendaftar dalam berbagai aktivitas</li>
                  <li>Mengetahui perbedaan usia antara orang</li>
                  <li>Merencanakan acara dan perayaan keluarga</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Penggunaan Profesional:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Menghitung usia pensiun dan perencanaan keuangan</li>
                  <li>Menentukan kelayakan untuk program dan layanan pemerintah</li>
                  <li>Asuransi kesehatan dan perhitungan premi</li>
                  <li>Pendaftaran dalam program pendidikan dan kursus</li>
                  <li>Prosedur hukum yang memerlukan penentuan usia yang tepat</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Penggunaan Medis:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Menentukan jadwal vaksinasi untuk anak-anak</li>
                  <li>Memantau pertumbuhan dan perkembangan sesuai tahap usia</li>
                  <li>Menghitung dosis obat yang sesuai</li>
                  <li>Menilai risiko kesehatan terkait usia</li>
                  <li>Merencanakan pemeriksaan medis rutin</li>
                </ul>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Pertanyaan Umum
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa itu usia Masehi?</h3>
              </div>
              <div className="info-section-body">
                Usia Masehi adalah cara yang kita gunakan untuk mengukur usia seseorang berdasarkan
                tanggal lahirnya menurut kalender Masehi bulanan dan tahunan. Kalender
                Masehi didasarkan pada siklus bumi mengelilingi matahari, dan tahun Masehi terdiri dari 365 hari dalam tahun biasa dan 366 hari dalam tahun kabisat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung usia Masehi?
                </h3>
              </div>
              <div className="info-section-body">
                Anda dapat menghitung usia Masehi dengan mudah menggunakan kalkulator elektronik kami.
                Mulailah dengan memasukkan tanggal lahir Anda (hari, bulan, dan tahun), lalu tekan tombol
                "Hitung Usia Saya". Kalkulator akan secara otomatis menghitung usia Anda dalam tahun, bulan,
                hari, jam, menit, dan detik, dengan mempertimbangkan tahun kabisat
                dan bulan dengan panjang yang berbeda.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah ada kalkulator untuk menghitung usia Masehi?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, kalkulator elektronik kami di halaman ini membantu Anda menghitung usia
                Masehi dengan sangat akurat. Anda cukup memasukkan tanggal lahir Anda ke dalam kalkulator
                dan kalkulator akan memberikan usia Anda yang tepat berdasarkan kalender Masehi, dengan
                informasi tambahan yang menarik seperti hari dalam minggu saat Anda lahir dan hari-hari
                tersisa hingga ulang tahun Anda berikutnya.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa saja kegunaan menghitung usia Masehi?
                </h3>
              </div>
              <div className="info-section-body">
                Perhitungan usia Masehi digunakan dalam banyak konteks penting seperti:
                <ul style={{ marginTop: "10px" }}>
                  <li>Merenungkan pengalaman hidup pribadi dan mengevaluasi pencapaian</li>
                  <li>Merencanakan masa depan dan menetapkan tujuan pribadi</li>
                  <li>Pendaftaran dalam layanan pendidikan dan pemerintah</li>
                  <li>Bidang asuransi, pensiun, dan perawatan kesehatan</li>
                  <li>Memantau pertumbuhan dan perkembangan anak</li>
                  <li>Prosedur hukum dan resmi</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bisakah usia Masehi dihitung secara manual?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, usia Masehi dapat dihitung secara manual menggunakan aturan
                Masehi, tetapi prosesnya membutuhkan banyak waktu dan tenaga.
                Mulailah dengan menentukan jumlah tahun antara tanggal lahir dan tanggal saat ini, lalu kurangi
                bulan dan hari dengan mempertimbangkan perbedaan panjang bulan dan tahun kabisat.
                Menggunakan kalkulator elektronik jauh lebih cepat dan akurat, karena memberikan hasil
                dalam hitungan detik dengan jaminan akurasi penuh.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Berapa lama lagi hingga ulang tahun saya?</h3>
              </div>
              <div className="info-section-body">
                Di antara informasi menarik yang diberikan sistem kami adalah mengetahui waktu yang tersisa
                dengan tepat hingga ulang tahun Anda berikutnya. Tanggal lahir dihitung dan
                sisa waktu diturunkan dalam hari dengan sangat akurat. Jika ulang tahun Anda jatuh pada
                hari ini, Anda dapat merayakan hari istimewa ini! Layanan ini juga berguna
                untuk mengetahui waktu tersisa untuk ulang tahun orang yang Anda cintai, untuk berbagi
                perayaan mereka dan membuatnya lebih istimewa.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa perbedaan antara menghitung usia dengan Masehi dan Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Kalender Masehi:</strong>
                </p>
                <ul>
                  <li>Berdasarkan siklus matahari (365 hari/366 pada tahun kabisat)</li>
                  <li>Digunakan secara global di sebagian besar negara</li>
                  <li>Musim tetap pada bulan yang sama setiap tahun</li>
                </ul>
                <p style={{ lineHeight: "1.8", marginTop: "10px" }}>
                  <strong>Kalender Hijriah:</strong>
                </p>
                <ul>
                  <li>Berdasarkan siklus bulan (354-355 hari)</li>
                  <li>Digunakan di negara-negara Islam</li>
                  <li>Perbedaan meningkat sekitar satu tahun setiap 33 tahun Masehi</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah kalkulator ini akurat dalam menghitung usia?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, kalkulator kami sangat akurat dalam menghitung usia. Kalkulator menggunakan
                persamaan pemrograman canggih yang mempertimbangkan semua faktor yang mempengaruhi seperti:
                <ul style={{ marginTop: "10px" }}>
                  <li>Tahun kabisat (tahun yang memiliki 366 hari)</li>
                  <li>
                    Perbedaan panjang bulan (beberapa 30 hari, beberapa 31 hari, dan Februari
                    28 atau 29)
                  </li>
                  <li>Perhitungan jam, menit, dan detik yang akurat</li>
                  <li>Perbedaan zona waktu</li>
                </ul>
                Ini memastikan Anda mendapatkan hasil 100% akurat.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculatorGregorian;